// import { endpointOrigin } from "./apiConfig";

import moment from "moment";
import { GetServerSidePropsContext } from "next";
import nookies, { parseCookies, setCookie } from "nookies";
import { IidpInput } from "../types/identityProvider";
import { postRefreshTokenManagement } from "./notifications";

export const endpointOrigin =
  process.env.NEXT_PUBLIC_STATE === "development"
    ? `${process.env.NEXT_PUBLIC_HOST}/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`
    : `/${process.env.NEXT_PUBLIC_API_URL}/managements/${process.env.NEXT_PUBLIC_API_VERSION}`;

export const getIdentityProvider = (urlOrigin?: string) => {
  return fetch(
    urlOrigin
      ? `${urlOrigin}${endpointOrigin}/identity-providers`
      : `${endpointOrigin}/identity-providers`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const getIdentityProviderEnable = (urlOrigin?: string) => {
  return fetch(
    urlOrigin
      ? `${urlOrigin}${endpointOrigin}/identity-providers?enabled=true`
      : `${endpointOrigin}/identity-providers?enabled=true`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const getIdentityProviderRoot = (
  urlOrigin?: string,
  context?: GetServerSidePropsContext,
  accessToken?: string,
  limit?: number,
  offset?: number
) => {
  const allCookies = context ? nookies.get(context) : parseCookies();
  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/identity-providers?sort=updatedAt:desc&limit=${
        limit ? limit : 15
      }&offset=${offset ? offset : 0}`
    : `${endpointOrigin}/identity-providers?sort=updatedAt:desc&limit=${
        limit ? limit : 15
      }&offset=${offset ? offset : 0}`;
  const token = accessToken
    ? accessToken
    : allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          if (context) {
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          } else {
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          }

          return fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
          })
            .then(async (response) => {
              if (response.ok) {
                return {
                  code: response.status,
                  result: await response.json(),
                };
              }
              throw new Error(`${url} : GET`);
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return {
          ...result,
          accessToken: token,
        };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const getTestError = (
  urlOrigin?: string,
  context?: GetServerSidePropsContext,
  accessToken?: string
) => {
  const allCookies = context ? nookies.get(context) : parseCookies();
  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/test-error`
    : `${endpointOrigin}/test-error`;
  const token = accessToken
    ? accessToken
    : allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async (response) => {
      if (response.ok) {
        return {
          code: response.status,
          result: await response.json(),
        };
      }
      throw new Error(`${url} : GET`);
    })
    .then(async (result) => {
      return {
        ...result,
        accessToken: token,
      };
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const loginIdentityProvider = (
  idp: string,
  body: any,
  urlOrigin?: string
) => {
  return fetch(
    urlOrigin
      ? `${urlOrigin}${endpointOrigin}/login/${idp}`
      : `${endpointOrigin}/login/${idp}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    }
  )
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then((result) => result)
    .catch((error: TypeError) => {
      return error;
    });
};

export const putIdentityProvider = (
  idpId: string,
  inputBody: any,
  urlOrigin?: string,
  context?: GetServerSidePropsContext,
  accessToken?: string
) => {
  const allCookies = context ? nookies.get(context) : parseCookies();
  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/identity-providers/${idpId}`
    : `${endpointOrigin}/identity-providers/${idpId}`;
  const token = accessToken
    ? accessToken
    : allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(inputBody),
  })
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          if (context) {
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          } else {
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          }

          return fetch(url, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify(inputBody),
          })
            .then(async (response) => {
              if (response.ok) {
                return {
                  code: response.status,
                  result: await response.json(),
                };
              }
              throw new Error(`${url} : PUT`);
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return {
          ...result,
          accessToken: token,
        };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const createIdentityProvider = (
  inputBody: IidpInput,
  urlOrigin?: string,
  context?: GetServerSidePropsContext,
  accessToken?: string
) => {
  const allCookies = context ? nookies.get(context) : parseCookies();
  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/identity-providers`
    : `${endpointOrigin}/identity-providers`;
  const token = accessToken
    ? accessToken
    : allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(inputBody),
  })
    .then(async (response) => {
      return {
        code: response.status,
        result: await response.json(),
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          if (context) {
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          } else {
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          }

          return fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
            body: JSON.stringify(inputBody),
          })
            .then(async (response) => {
              if (response.ok) {
                return {
                  code: response.status,
                  result: await response.json(),
                };
              }
              throw new Error(`${url} : POST`);
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return {
          ...result,
          accessToken: token,
        };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};

export const deleteIdentityProvider = (
  idpId: string,
  urlOrigin?: string,
  context?: GetServerSidePropsContext,
  accessToken?: string
) => {
  const allCookies = context ? nookies.get(context) : parseCookies();
  const url = urlOrigin
    ? `${urlOrigin}${endpointOrigin}/identity-providers/${idpId}`
    : `${endpointOrigin}/identity-providers/${idpId}`;
  const token = accessToken
    ? accessToken
    : allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as string];

  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(async (response) => {
      return {
        code: response.status,
      };
    })
    .then(async (result) => {
      if (result.code === 401) {
        const rsRefreshToken = await postRefreshTokenManagement(
          allCookies[process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any]
        );
        if (rsRefreshToken.accessToken && rsRefreshToken.refreshToken) {
          if (context) {
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            nookies.set(
              context,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          } else {
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_REFRESH_TOKEN as any,
              rsRefreshToken.refreshToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
            setCookie(
              null,
              process.env.NEXT_PUBLIC_COOKIE_KEY_TOKEN as any,
              rsRefreshToken.accessToken,
              {
                path: "/",
                expires: moment().add(7, "days").toDate(),
                sameSite: "strict",
              }
            );
          }

          return fetch(url, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${rsRefreshToken.accessToken}`,
            },
          })
            .then(async (response) => {
              if (!response.ok) {
                const error: any = new Error(
                  `An error occurred while fetching ${url} : DELETE`
                );
                error.status = response.status;

                throw new Error(error);
              }

              return {
                code: response.status,
              };
            })
            .then((rs) => {
              return { ...rs, accessToken: rsRefreshToken.accessToken };
            })
            .catch((_error) => ({ code: 401 }));
        } else {
          return { code: 401 };
        }
      } else {
        return {
          ...result,
          accessToken: token,
        };
      }
    })
    .catch((error: TypeError) => {
      return error;
    });
};
